import { WEB_SERVICES } from "../../../../bitSagas/webServices";
import { USER_TYPE } from '../../../../bitConstants/constants';
import { WEBSERVICE_ERRORS } from "../../../errorCatalog";

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    common: {
      BUSINESS_ERRORS: {
        INCOMPATIBLE_CLIENT_PRODUCTS: errorToPrint.INCOMPATIBLE_PRODUCT,
        PRODUCT_REGISTERED: errorToPrint.PRODUCT_REGISTERED,
        NON_FUSION_CURRENT_PORTFOLIO: errorToPrint.NON_FUSION_CURRENT_PORTFOLIO,
        ADDITIONAL_R2R_ERROR: errorToPrint.ADDITIONAL_R2R_ERROR,
        SIGNATURE_IFRAME_ERROR: errorToPrint.SIGNATURE_IFRAME_ERROR,
        WITHOUT_REQUIRED_DATA_TO_SIGN: errorToPrint.WITHOUT_REQUIRED_DATA_TO_SIGN,
        WITHOUT_URL_TO_SIGN: errorToPrint.WITHOUT_URL_TO_SIGN,
        ONBOARDING_NEEDED: errorToPrint.ONBOARDING_NEEDED,
        AUTO_RENEWAL_FAIL: errorToPrint.AUTO_RENEWAL_FAIL,
      },
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
        },
        [WEB_SERVICES.UPDATE_CQ]: {
          [WEBSERVICE_ERRORS.INSUFFICIENT_CREDIT_LIMIT]: errorToPrint.INSUFFICIENT_CREDIT_LIMIT,
          [WEBSERVICE_ERRORS.ONBOARDING_NEEDED]: errorToPrint.ONBOARDING_NEEDED,
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
        },
      },
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  };

  return handledErrors;
};